import Vue from 'vue'
import waves from './waves/index'
import tooltips from './tooltips/index'
import drag from './dragModal/index'
import permission from './permission/index'
import developing from './developing/index'


// 全局使用自定义指令
Vue.use(waves);
Vue.use(tooltips);
Vue.use(drag);
Vue.use(permission);
Vue.use(developing);



// WEBPACK FOOTER //
// ./src/directive/index.js